import {IdCodeNameModel} from 'common-shared';

export class UnitModel extends IdCodeNameModel {
  PhysicalDimensionClv: string;
  RoundingFactor?: number;
  Comment?: string;


  constructor(init?: Partial<UnitModel>) {
    super();
    Object.assign(this, init);
  }
}
